import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  margin-bottom: 24px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    button {
      width: 100%;
    }
  }
`;

export const FileImg = styled.img`
  width: 30px;
  height: 30px;
  display: block;
`;

export const InputContainer = styled.form`
  margin-top: -24px;
  min-width: calc(80vw - 100px);
  max-width: 960px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  @media ${(props) => props.theme.device.laptop} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 1fr;
  }
`;
